"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _userEntries = _interopRequireDefault(require("../year/my-account/my-entries/user-entries"));
var _linkButton = _interopRequireDefault(require("../core/link-button"));
var _constantParams = require("../../constant-params");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var _ref = /*#__PURE__*/_react.default.createElement("p", null, "You have successfully entered the competitions.");
var _ref2 = /*#__PURE__*/_react.default.createElement("h2", null, "Your Entries for ", _constantParams.thisYear);
var _ref3 = /*#__PURE__*/_react.default.createElement(_userEntries.default, {
  yearID: _constantParams.thisYear
});
class CheckoutSuccess extends _react.Component {
  render() {
    const MYENTRIES_URL = `/year/${_constantParams.thisYear}/my-account/my-entries`;
    return /*#__PURE__*/_react.default.createElement("div", null, _ref, _ref2, _ref3, /*#__PURE__*/_react.default.createElement(_linkButton.default, {
      "data-test-id": "my-account-button",
      to: MYENTRIES_URL,
      type: "primary",
      block: true
    }, "See this and other years at 'My Account'"));
  }
}
var _default = exports.default = CheckoutSuccess;